import React from 'react';
import { InlineLink, Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { FormattedMessage } from 'react-intl';

interface PageAPITooltipContentProps extends Pick<React.ComponentProps<typeof Text>, 'color'> {}

export const PageAPITooltipContent: React.FC<PageAPITooltipContentProps> = ({
  color = 'default',
}) => (
  <Text appearance="bodySmall" color={color}>
    {intl.formatMessage({
      defaultMessage: `Use the Set Page Properties API to name pages and capture properties based on actions that your users take on your pages.`,
      id: 'sZGlzR',
    })}{' '}
    <InlineLink
      // TODO: @juliarapoport replace with correct link when it becomes available
      href="https://help.fullstory.com/hc/en-us/articles/360052331173-Pages-in-Fullstory#01FE48A345M5CG2WYGSHSWE7K3"
      newTab
    >
      <FormattedMessage defaultMessage="Learn more" id="TdTXXf" />
    </InlineLink>
  </Text>
);
